(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const SECTIONS = 'cart-drawer,header';
  const drawer = () => $('[data-cart-drawer]');
  let lastFocus = null;

  const open = () => {
    const d = drawer(); if (!d) return;
    lastFocus = document.activeElement;
    void d.offsetWidth; // force le calcul du style pour l'animation
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-open');
    setTimeout(() => $('.cdrawer__panel', d)?.focus(), 60);
  };
  const close = () => {
    const d = drawer(); if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-open');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  };
  const showError = msg => {
    const d = drawer(); const el = d && $('[data-cart-error]', d);
    if (!el) return;
    el.textContent = msg; el.hidden = !msg;
  };

  /* Remplace le tiroir et le compteur du header par le HTML renvoyé par Shopify */
  const render = sections => {
    if (!sections) return;
    const parse = html => new DOMParser().parseFromString(html, 'text/html');
    const old = drawer();
    if (sections['cart-drawer'] && old) {
      const fresh = $('[data-cart-drawer]', parse(sections['cart-drawer']));
      if (fresh) {
        if (old.classList.contains('is-open')) { fresh.classList.add('is-open'); fresh.setAttribute('aria-hidden', 'false'); }
        old.replaceWith(fresh);
      }
    }
    if (sections.header) {
      const fresh = $('.cart-link', parse(sections.header)), cur = $('.cart-link');
      if (fresh && cur) cur.replaceWith(fresh);
    }
  };

  const setBusy = on => { const d = drawer(); if (d) { d.classList.toggle('is-loading', on); d.setAttribute('aria-busy', String(on)); } };

  /* Ajout au panier sans quitter la page */
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (e.submitter && (e.submitter.name === 'checkout' || e.submitter.closest('.shopify-payment-button'))) return; // paiement express : comportement Shopify
    const d = drawer(); if (!d) return;
    e.preventDefault();
    const btns = [...document.querySelectorAll('button[type=submit]')].filter(b => b.form === form);
    btns.forEach(b => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    try {
      const fd = new FormData(form);
      if (!fd.get('quantity')) fd.set('quantity', '1');
      fd.append('sections', SECTIONS);
      fd.append('sections_url', location.pathname);
      const res = await fetch(d.dataset.addUrl + '.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } });
      const data = await res.json();
      if (!res.ok) { showError(data.description || data.message || 'Impossible d\'ajouter cet article.'); open(); return; }
      render(data.sections);
      showError('');
      open();
    } catch (err) {
      form.submit(); // secours : comportement Shopify classique
    } finally {
      btns.forEach(b => { b.disabled = false; b.removeAttribute('aria-busy'); });
    }
  });

  /* Quantité / suppression */
  const change = async (line, quantity) => {
    const d = drawer(); if (!d) return;
    setBusy(true);
    try {
      const res = await fetch(d.dataset.changeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: SECTIONS, sections_url: location.pathname })
      });
      const data = await res.json();
      if (!res.ok) { showError(data.description || data.message || 'Mise à jour impossible.'); return; }
      render(data.sections);
      showError('');
    } catch (err) {
      showError('Connexion impossible. Réessayez.');
    } finally { setBusy(false); }
  };

  document.addEventListener('click', e => {
    const t = e.target;
    const opener = t.closest('[data-cart-open]');
    if (opener && drawer()) { e.preventDefault(); open(); return; }
    if (t.closest('[data-cart-close]')) { close(); return; }
    const q = t.closest('[data-cart-drawer] [data-qty]');
    if (q) {
      const item = q.closest('[data-line]');
      if (item) change(Number(item.dataset.line), Math.max(0, Number(q.dataset.qty)));
    }
  });

  document.addEventListener('keydown', e => {
    const d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') { // garde le focus dans le tiroir
      const f = [...d.querySelectorAll('a[href],button:not([disabled]),input,[tabindex="0"]')].filter(x => x.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === d.querySelector('.cdrawer__panel'))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
